import * as React from "react";
import { Link } from "react-router";

const css = require("./not-found.scss");
const notFoundImage = require("./not-found.svg");

export interface NotFoundProps {
  goBackLinkText?: string;
  goBackTo?: string;
  message?: string;
  styles?: any;
}

export class NotFound extends React.Component<NotFoundProps, {}> {
  public static defaultProps: NotFoundProps = {
    styles: css,
    message: "It looks like you got lost.",
  };

  public render() {
    const { styles, goBackLinkText, goBackTo, message } = this.props;

    return (
      <div className={styles.container}>
        <div>
          <img alt="" role="presentation" className={styles.image} src={notFoundImage} />
          <div className={styles.text}>{message}</div>
          {goBackLinkText && goBackTo ? (
            <div className={styles["link-wrapper"]}>
              <Link to={goBackTo} className={styles.link}>
                {goBackLinkText}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
